import { render, staticRenderFns } from "./ModalCustomerAccess.vue?vue&type=template&id=5bfa8076"
import script from "./ModalCustomerAccess.vue?vue&type=script&lang=js"
export * from "./ModalCustomerAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports